/* @flow */

import React from 'react';
import Tappable from 'app/components/commons/Tappable';
import { hover } from 'app/utils/cssUtils';
import colorUtils from 'color';
import useSheet from 'app/jss';

type Props = {
  children: any,
  classes: Object,
  onSelect?: () => void
};

const defaultProps = {
  onSelect: undefined
};

function LineUpButton({ children, classes, onSelect }: Props) {
  return (
    <Tappable onTap={onSelect} className={classes.lineupRow}>
      <div className={classes.lineRowLabel}>{children}</div>
      <div className={classes.lineRowIcon}>
        <span className="ion-ios-plus-outline" />
      </div>
    </Tappable>
  );
}

LineUpButton.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    lineupRow: {
      borderBottom: `1px solid ${theme.color.basis6}`,
      alignItems: 'center',
      backgroundColor: theme.color.white,
      color: theme.color.basis1,
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: 7,
      paddingBottom: 7,
      paddingLeft: 10,
      textTransform: 'uppercase',
      transition: 'all linear 0.2s',
      ...hover({
        backgroundColor: colorUtils(theme.color.white)
          .darken(0.05)
          .hex()
      })
    },
    lineRowLabel: {
      flexGrow: 1,
      fontSize: theme.fontSize.small
    },
    lineRowIcon: {
      color: theme.color.basis1,
      display: 'flex',
      fontSize: 28,
      justifyContent: 'center',
      width: '2.5rem'
    }
  };
}

export default useSheet(applyStyles)(LineUpButton);
